// import { useEffect, useState, useCallback } from "react";
// import { toast } from "react-toastify";
// import { getTreeSpeciesApi } from "../../apis/treeSpeciesApi";

// export const useTreeSpecies = (filters, currentPage, entriesPerPage) => {
//   const [species, setSpecies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [totalCount, setTotalCount] = useState(0);

//   const fetchSpecies = useCallback(async (silent = false) => {
//     setLoading(true);
//     setError(null);

//     let toastId = null;
//     if (!silent) {
//       toastId = toast.loading("Loading tree species...");
//     }

//     try {
//       const data = await getTreeSpeciesApi(filters, currentPage, entriesPerPage);

//       if (data?.data) {
//         setSpecies(data.data);
//         setTotalCount(data.pagination?.count || data.data.length);
//       } else if (data?.results) {
//         setSpecies(data.results);
//         setTotalCount(data.count || 0);
//       } else {
//         setSpecies([]);
//         setTotalCount(0);
//       }

//       if (toastId) {
//         toast.update(toastId, {
//           render: "Tree species loaded",
//           type: "success",
//           isLoading: false,
//           autoClose: 1500,
//         });
//       }
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.detail ||
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to load tree species";

//       if (toastId) {
//         toast.update(toastId, {
//           render: errorMessage,
//           type: "error",
//           isLoading: false,
//         });
//       } else {
//         toast.error(errorMessage);
//       }

//       setError(errorMessage);
//       console.error("Failed to fetch tree species:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [filters, currentPage, entriesPerPage]);

//   useEffect(() => {
//     fetchSpecies(true); // silent on initial load / filter change
//   }, [fetchSpecies]);

//   // Optional: expose refetch method that shows feedback
//   const refetch = () => fetchSpecies(false);

//   return { species, loading, error, totalCount, setSpecies, refetch };
// };

import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { getTreeSpeciesApi } from "../../apis/treeSpeciesApi";

export const useTreeSpecies = (filters, currentPage, entriesPerPage) => {
  const [species, setSpecies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  const extractError = (err) => {
   // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to load tree species.",
    };
  };

  const fetchSpecies = useCallback(
    async (silent = false) => {
      setLoading(true);
      setError(null);

      let toastId = null;
      if (!silent) {
        toastId = toast.loading("Loading tree species...");
      }

      try {
        const data = await getTreeSpeciesApi(
          filters,
          currentPage,
          entriesPerPage
        );

        if (data?.data) {
          setSpecies(data.data);
          setTotalCount(data.pagination?.count || data.data.length);
        } else if (data?.results) {
          setSpecies(data.results);
          setTotalCount(data.count || 0);
        } else {
          setSpecies([]);
          setTotalCount(0);
        }

        if (toastId) {
          toast.update(toastId, {
            render: (
              <div>
                <strong>Success</strong>
                <div>Tree species loaded successfully.</div>
              </div>
            ),
            type: "success",
            isLoading: false,
            autoClose: 1500,
          });
        }
      } catch (err) {
        const { title, issue } = extractError(err);

        if (toastId) {
          toast.update(toastId, {
            render: (
              <div>
                <strong>{title}</strong>
                <div>{issue}</div>
              </div>
            ),
            type: "error",
            isLoading: false,
          });
        } else {
          toast.error(
            <div>
              <strong>{title}</strong>
              <div>{issue}</div>
            </div>
          );
        }

        setError({ title, issue });
        console.error("Failed to fetch tree species:", err);
      } finally {
        setLoading(false);
      }
    },
    [filters, currentPage, entriesPerPage]
  );

  useEffect(() => {
    fetchSpecies(true); // silent on mount & filter changes
  }, [fetchSpecies]);

  const refetch = () => fetchSpecies(false);

  return { species, loading, error, totalCount, setSpecies, refetch };
};